import Vue from "vue";
import Vuex from "vuex";
import { vm } from "@/main";

// Modulos
import administracion from "../modules/administracion";
import lineas from "../modules/lineas";
import charter from "../modules/charter";
import shippinginstructions from "../modules/shippinginstructions";
import modulosLogin from "../modules/modulosLogin";
import superadministrador from "../modules/superadministrador";
import serviciosLogisticos from "@/modules/serviciosLogisticos";

// Secciones
import seccionesSuperAdministrador from "../modules/seccionesModulos/seccionesSuperAdministrador";
import seccionesAdministrador from "../modules/seccionesModulos/seccionesAdministrador";
import seccionesLineas from "../modules/seccionesModulos/seccionesLineas";
import seccionesShippingInstructions from "../modules/seccionesModulos/seccionesShippingInstructions";

// Subsecciones
import subseccionesAdministrador from "../modules/subSeccionesModulos/subseccionesAdministrador";
import subseccionesLineas from "../modules/subSeccionesModulos/subseccionesLineas";
import liquidations from "@/modules/liquidations";

Vue.use(Vuex);

// Opciones generales
export default new Vuex.Store({
  state: {
    url_actual: "/dashboard",
    seccion_actual: "",
    sub_seccion_actual: "",
    filiales: [],
    paises: [],
    listaPaises: [],
    zonas: [],
    regiones: [],
    listaRegiones: [],
    provincias: [],
    comunas: [],
    localidades: [],
    direcciones: [],
    destinos: [],
    puertos: [],
    // Lineas-Bookings
    clientes: [],
    navieras: [],
    naves: [],
    comerciales: [],
    productos: [],
    tipo_servicio_integral: [],
    motivo: [],
    contratos: [],
    servicio_integral: [
      {
        id: 1,
        name: "Si",
      },
      {
        id: 2,
        name: "No",
      },
    ],

    // End Lineas-Bookings
    // Tarifas
    tipoContratos: [
      {
        id: 1,
        name: "Simple",
      },
      {
        id: 2,
        name: "Múltiple",
      },
    ],

    commodity: [],
    atmosferas: [],
    contenedores: [],
    estadoAcuerdoLinea: [], // acuerdos clientes

    currencies : [],
    estadoContact: false,

    estados: [
      { id: 0, name: "Despublicadas" },
      { id: 1, name: "Publicadas" },
    ],
    pod: [],
    pol: [],

    // Fin Tarifas
    loading: false,
    loadingTable: false,
    loadingTableModal: false,
    loadingServiciosBooking: false,

    // Diego
    loadingServiciosPuertos: false,
    loadingServiciosTransbordos: false,
    loadingDestinoFinalItinerarios: false,

    // Daniel
    loadingItinerariosTransbordos: false,

    cargarTabla: false,
    refrescarTable: false,
    confirmacionBtnEliminar: false,
    visibleModalEditar: false,
    visibleModalEditarBookingConfirmado: false,
    visibleModalEditarBookingEmbarcado: false,
    visibleModalEditarBookingPorAceptar: false,
    visibleModalEditarSolicitudModificacion: false,
    visibleModalInformacionGeneral: false,
    visibleModalTracking: false,
    visibleModalVerTracking: false,
    visibleModalBL: false,
    visibleModalDetalleBL: false,
    visibleModalHistorial: false,

    visibleModalEditarProveedoresCoordinadores: false,
    visibleModalEditarProveedoresConductores: false,
    visibleModalEditarProveedoresCamiones: false,
    visibleModalEditarProveedoresDatosBancarios: false,
    visibleModalEditarEmbarcadoresDirecciones: false,
    visibleModalEditarEmbarcadoresContactos: false,
    visibleModalEditarClientesProductos: false,
    token: "",
    isAdmin: false,
    usuarioActual: [],
    // isLoadPage: false,

    // Loading state aux
    uploadFileLoading: false,
    uploadFileLoadingError: false,
    uploadFileId: "",
    anios: [],

    listaClientesUsuarioActual: [],
    dataDiasSemana: [
      { id: 1, name: "Lunes" },
      { id: 2, name: "Martes" },
      { id: 3, name: "Miércoles" },
      { id: 4, name: "Jueves" },
      { id: 5, name: "Viernes" },
      { id: 6, name: "Sábado" },
      { id: 7, name: "Domingo" },
    ],

    listaPallets: [],
    // Data de Buscar Itinerario - Reciclado
    // 1.-
    numSemanasOptions: [
      { label: "+1", value: "1" },
      { label: "+2", value: "2" },
      { label: "+3", value: "3" },
    ],
    // 2.-
    tipoCargaOptions: [
      { label: "Reefer", value: "reefer" },
      { label: "Dry", value: "dry" },
    ],

    lineasSinContrato: [
      { id: 0, name: "No Incluir" },
      { id: 1, name: "Incluir" },
    ],
    zIndexModal: false,
    zIndexTablaModal: false,
    // TARIFAS
    showAcuerdoLineas: false,
    showAcuerdoLineasClienteBase: false,
    showModalAcuerdoLineasClienteBase: false,

    showAcuerdoClientes: false,
    showModalAcuerdoLineasCliente: false,
    // state tipo proveedor
    estadoTipoProveedor: {},
    // Descuentos Clientes
    showDescuentosClientes: false,
    showModalDescuentosClientes: false,

    showShippingPorEnviar: false,
    showShippingPorAprobar: false,
    showShippingEnviadas: false,
    showShippingConfirmadas: false,
    showShippingRechazadas: false,
    showShippingTemplates: false,
    isSuperAdmin: false,

    showModalBooking: false,
    avatarMiniatura: '',
    tokenValidationPage: "",
    payers: [] ,
    extraCost: [] ,
    tiers: [
      {
        id : 1 ,
        name : '1' ,
      },
      {
        id : 2 ,
        name : '2' ,
      },
      {
        id : 3 ,
        name : '3' ,
      },
      {
        id : 4 ,
        name : '4' ,
      },
      {
        id : 5 ,
        name : '5' ,
      }
    ]

  },

  // 2
  mutations: {
    // login
    cambiarToken(state, payload) {
      state.token = payload;
    },

    cambiarUsuarioActual(state, payload) {
      state.usuarioActual = payload;
    },

    cerrarSesion(state) {
      state.token = "";
      state.isAdmin = false;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("estilos_modulos");
      localStorage.removeItem("estilos_secciones");
      localStorage.removeItem("estilos_subsecciones");
      localStorage.removeItem("datComplex");
      localStorage.removeItem("roleStructure");
      localStorage.removeItem("userStructure");
      sessionStorage.removeItem("load");
      vm.$router.push("/login");
    },

    cambiarIsAdmin(state, payload) {
      state.isAdmin = payload;
    },

    cambiarIsSuperAdmin(state, payload) {
      state.isSuperAdmin = payload;
    },

    cambiarUrl(state, payload) {
      state.url_actual = payload;
    },

    cambiarSeccionActual(state, payload) {
      state.seccion_actual = payload;
    },

    cambiarSubSeccionActual(state, payload) {
      state.sub_seccion_actual = payload;
    },

    setFiliales(state, payload) {
      state.filiales = payload;
    },

    setPaises(state, payload) {
      // Actulización de state
      state.paises = payload;

      // Actualización de variables en localStorage (Esta funcionalidad se ejecuta solo cuando la variable load es 1)
      // Load se utilza como variable auxiliar, esto quiere decir que la app se actualizo una vez que se a iniciado sesion (Bugs con menu "Bootstarp + jquery", al iniciar sesión)
      if (sessionStorage.getItem("load") == 1) {
        // Obtención desde local storage y parsea el valor datComplex
        let dataStorage = JSON.parse(localStorage.getItem("datComplex"));

        // Si la variable obtenida desde local storage no es nula accede
        if (dataStorage != null) {
          dataStorage.lista_paises = payload; // Sobreescribe los valores de lista_paises en localstorage
          localStorage.setItem("datComplex", JSON.stringify(dataStorage)); // Vuelve a codificar el array y lo guarda nuevamente en localstorage
        }
      }
    },

    setZonas(state, payload) {
      state.zonas = payload;
    },

    setRegiones(state, payload) {
      // Actulización de state
      state.regiones = payload;

      let regionesAux = [];

      // Obtención de solo regiones para lista
      payload.map((item) => {
        regionesAux.push(item);
      });

      state.listaRegiones = regionesAux;

      // Actualización de variables en localStorage (Esta funcionalidad se ejecuta solo cuando la variable load es 1)
      // Load se utilza como variable auxiliar, esto quiere decir que la app se actualizo una vez que se a iniciado sesion (Bugs con menu "Bootstarp + jquery", al iniciar sesión)
      if (sessionStorage.getItem("load") == 1) {
        // Obtención desde local storage y parsea el valor datComplex
        let dataStorage = JSON.parse(localStorage.getItem("datComplex"));

        // Si la variable obtenida desde local storage no es nula accede
        if (dataStorage != null) {
          dataStorage.lista_regiones = payload; // Sobreescribe los valores de lista_paises en localstorage
          localStorage.setItem("datComplex", JSON.stringify(dataStorage)); // Vuelve a codificar el array y lo guarda nuevamente en localstorage
        }
      }
    },

    setProvincias(state, payload) {
      state.provincias = payload;

      // Actualización de variables en localStorage (Esta funcionalidad se ejecuta solo cuando la variable load es 1)
      // Load se utilza como variable auxiliar, esto quiere decir que la app se actualizo una vez que se a iniciado sesion (Bugs con menu "Bootstarp + jquery", al iniciar sesión)
      if (sessionStorage.getItem("load") == 1) {
        // Obtención desde local storage y parsea el valor datComplex
        let dataStorage = JSON.parse(localStorage.getItem("datComplex"));

        // Si la variable obtenida desde local storage no es nula accede
        if (dataStorage != null) {
          dataStorage.lista_provincias = payload; // Sobreescribe los valores de lista_paises en localstorage
          localStorage.setItem("datComplex", JSON.stringify(dataStorage)); // Vuelve a codificar el array y lo guarda nuevamente en localstorage
        }
      }
    },

    setComunas(state, payload) {
      state.comunas = payload;

      // Actualización de variables en localStorage (Esta funcionalidad se ejecuta solo cuando la variable load es 1)
      // Load se utilza como variable auxiliar, esto quiere decir que la app se actualizo una vez que se a iniciado sesion (Bugs con menu "Bootstarp + jquery", al iniciar sesión)
      if (sessionStorage.getItem("load") == 1) {
        // Obtención desde local storage y parsea el valor datComplex
        let dataStorage = JSON.parse(localStorage.getItem("datComplex"));

        // Si la variable obtenida desde local storage no es nula accede
        if (dataStorage != null) {
          dataStorage.lista_comunas = payload; // Sobreescribe los valores de lista_paises en localstorage
          localStorage.setItem("datComplex", JSON.stringify(dataStorage)); // Vuelve a codificar el array y lo guarda nuevamente en localstorage
        }
      }
    },

    setLocalidades(state, payload) {
      state.localidades = payload;
    },

    setTipoTier(state, payload) {
      state.tipoTiers = payload;
    },

    setDirecciones(state, payload) {
      state.direcciones = payload;
    },

    setDestinos(state, payload) {
      state.destinos = payload;
    },

    setPuertos(state, payload) {
      state.puertos = payload;
    },

    setPayers(state, payload) {
      state.payers = payload;
    },

    // Lineas-Bookings

    setClientes(state, payload) {
      state.clientes = payload;
    },
    setServicioIntegral(state, payload) {
      state.servicio_integral = payload;
    },

    setNavieras(state, payload) {
      state.navieras = payload;
    },
    setNaves(state, payload) {
      state.naves = payload;
    },
    setTipoContratos(state, payload) {
      state.tipoContratos = payload;
    },
    setCommodity(state, payload) {
      state.commodity = payload;
    },
    setContenedores(state, payload) {
      state.contenedores = payload;
    },
    setEstadoAcuerdoLinea(state, payload) {
      state.estadoAcuerdoLinea = payload;
    },


    setEstadoContact(state, payload) {
      state.estadoContact = payload;
    },



    setPod(state, payload) {
      state.pod = payload;
    },
    setPol(state, payload) {
      state.pol = payload;
    },

    setAtmosferas(state, payload) {
      state.atmosferas = payload;
    },

    setComerciales(state, payload) {
      state.comerciales = payload;
    },

    setProductos(state, payload) {
      state.productos = payload;
    },
    setTipoServicioIntegral(state, payload) {
      state.tipo_servicio_integral = payload;
    },

    setMotivo(state, payload) {
      state.motivo = payload;
    },

    setContratos(state, payload) {
      state.contratos = payload;
    },

    // End Lineas-Bookings

    setCargarTabla(state, payload) {
      state.cargarTabla = payload;
    },

    setRefrescarTable(state, payload) {
      state.refrescarTable = payload;
    },

    setLoading(state, payload) {
      state.loading = payload;
    },

    setLoadingTable(state, payload) {
      state.loadingTable = payload;
    },

    setLoadingTableModal(state, payload) {
      state.loadingTableModal = payload;
    },

    setConfirmacionBtnEliminar(state, payload) {
      state.confirmacionBtnEliminar = payload;
    },

    setVisibleModalEditar(state, payload) {
      state.visibleModalEditar = payload;
    },
    setVisibleModalEditarBookingConfirmado(state, payload) {
      state.visibleModalEditarBookingConfirmado = payload;
    },
    setVisibleModalEditarBookingEmbarcado(state, payload) {
      state.visibleModalEditarBookingEmbarcado = payload;
    },
    setVisibleModalEditarBookingPorAceptar(state, payload) {
      state.visibleModalEditarBookingPorAceptar = payload;
    },
    setVisibleModalEditarSolicitudModificacion(state, payload) {
      state.visibleModalEditarSolicitudModificacion = payload;
    },

    setVisibleModalTracking(state, payload) {
      state.visibleModalTracking = payload;
    },
    setVisibleModalVerTracking(state, payload) {
      state.visibleModalVerTracking = payload;
    },
    setVisibleModalBL(state, payload) {
      state.visibleModalBL = payload;
    },

    setVisibleModalDetalleBL(state, payload) {
      state.visibleModalDetalleBL = payload;
    },

    setVisibleModalHistorial(state, payload) {
      state.visibleModalHistorial = payload;
    },

    //estado tipo proveedor
    setEstadoTipoProveedor(state, payload) {
      state.estadoTipoProveedor = payload;
    },

    setVisibleModalInformacionGeneral(state, payload) {
      state.visibleModalInformacionGeneral = payload;
    },

    setVisibleModalEditarProveedoresCoordinadores(state, payload) {
      state.visibleModalEditarProveedoresCoordinadores = payload;
    },

    setVisibleModalEditarProveedoresConductores(state, payload) {
      state.visibleModalEditarProveedoresConductores = payload;
    },

    setVisibleModalEditarProveedoresCamiones(state, payload) {
      state.visibleModalEditarProveedoresCamiones = payload;
    },

    setVisibleModalEditarProveedoresDatosBancarios(state, payload) {
      state.visibleModalEditarProveedoresDatosBancarios = payload;
    },

    setVisibleModalEditarEmbarcadoresDirecciones(state, payload) {
      state.visibleModalEditarEmbarcadoresDirecciones = payload;
    },

    setVisibleModalEditarEmbarcadoresContactos(state, payload) {
      state.visibleModalEditarEmbarcadoresContactos = payload;
    },

    // Loading state aux
    setUploadFileLoading(state, payload) {
      state.uploadFileLoading = payload;
    },

    setUploadFileLoadingError(state, payload) {
      state.uploadFileLoadingError = payload;
    },

    setAnios(state, payload) {
      state.anios = payload;
    },

    setListaPallets(state, payload) {
      state.listaPallets = payload;
    },

    setUploadFileId(state, payload) {
      state.uploadFileId = payload;
    },

    setListaClientesUsuarioActual(state, payload) {
      state.listaClientesUsuarioActual = payload;
    },

    setLoadingServiciosBooking(state, payload) {
      state.loadingServiciosBooking = payload;
    },

    setLoadingServiciosPuertos(state, payload) {
      state.loadingServiciosPuertos = payload;
    },
    setLoadingServiciosTransbordos(state, payload) {
      state.loadingServiciosTransbordos = payload;
    },

    setLoadingDestinoFinalItinerarios(state, payload) {
      state.loadingDestinoFinalItinerarios = payload;
    },

    setLoadingItinerariosTransbordos(state, payload) {
      state.loadingItinerariosTransbordos = payload;
    },

    setZindexModal(state, payload) {
      state.zIndexModal = payload;
    },

    setZindexTablaModal(state, payload) {
      state.zIndexTablaModal = payload;
    },


    setShowAcuerdoLineas(state, payload) {
      state.showAcuerdoLineas = payload;
    },
    setShowAcuerdoLineasClienteBase(state, payload) {
      state.showAcuerdoLineasClienteBase = payload;
    },
    setShowAcuerdoClientes(state, payload) {
      state.showAcuerdoClientes = payload;
    },
    setShowModalAcuerdoLineasClienteBase(state, payload) {
      state.showModalAcuerdoLineasClienteBase = payload;
    },
    // Descuentos Clientes
    setShowDescuentosClientes(state, payload) {
      state.showDescuentosClientes = payload;
    },
    // Shipping Instructions
    setShowShippingPorEnviar(state, payload) {
      state.showShippingPorEnviar = payload;
    },
    setShowShippingPorAprobar(state, payload) {
      state.showShippingPorAprobar = payload;
    },
    setShowShippingEnviadas(state, payload) {
      state.showShippingEnviadas = payload;
    },
    setShowShippingConfirmadas(state, payload) {
      state.showShippingConfirmadas = payload;
    },
    setShowShippingRechazadas(state, payload) {
      state.showShippingRechazadas = payload;
    },
    setShowShippingTemplates(state, payload) {
      state.showShippingTemplates = payload;
    },

    setShowModalBooking(state, payload) {
      state.showModalBooking = payload;
    },

    setAvatarMiniatura(state, payload) {
      state.avatarMiniatura = payload;
    },

    setTokenValidationPage(state, payload) {
      state.tokenValidationPage = payload;
    },

    setCurrencies(state, payload) {
      state.currencies = payload;
    },
    setExtraCost(state, payload) {
      state.extraCost = payload;
    },
  },

  // 1
  actions: {
    AccionCambiarToken({ commit }, data) {
      commit("cambiarToken", data);
    },

    AccionCambiarUsuarioActual({ commit }, data) {
      commit("cambiarUsuarioActual", data);
    },

    AccionCerrarSesion({ commit }) {
      commit("cerrarSesion");
    },

    // cambiarIsLoadPage(state, payload) {
    //   state.isLoadPage = payload;
    // },

    // AccionIsLoadPage({ commit }) {
    //   commit("cambiarIsLoadPage");
    // },

    AccionCambiarAdmin({ commit }, data) {
      commit("cambiarIsAdmin", data);
    },

    AccionCambiarSuperAdmin({ commit }, data) {
      commit("cambiarIsSuperAdmin", data);
    },

    // Cambiarestado de login
    AccionCambiarLogin({ commit }, estado) {
      commit("cambiarLogin", estado);
    },

    // Cambiar URL en "breadcrumbs"
    AccionCambiar({ commit }, url) {
      // Commit cambiar Url
      commit("cambiarUrl", url);

      // Separación de url
      let aux = url.split("/");

      // Si esta esta es un submenu lo motara en cambiarSubSeccionActual
      if (aux.length >= 3) {
        let sub = aux[aux.length - 2];
        commit("cambiarSubSeccionActual", sub);
      } else {
        commit("cambiarSubSeccionActual", "");
      }
    },

    // Cambia nombre de modulo actual
    AccionCambiarSeccionActual({ commit }, url) {
      commit("cambiarSeccionActual", url);
    },

    ActionSetFiliales({ commit }, data) {
      commit("setFiliales", data);
    },

    ActionSetPaises({ commit }, data) {
      commit("setPaises", data);
    },

    ActionSetZonas({ commit }, data) {
      commit("setZonas", data);
    },

    ActionSetRegiones({ commit }, data) {
      commit("setRegiones", data);
    },

    ActionSetProvincias({ commit }, data) {
      commit("setProvincias", data);
    },

    ActionSetComunas({ commit }, data) {
      commit("setComunas", data);
    },

    ActionSetLocalidades({ commit }, data) {
      commit("setLocalidades", data);
    },

    ActionSetDirecciones({ commit }, data) {
      commit("setDirecciones", data);
    },

    ActionSetDestinos({ commit }, data) {
      commit("setDestinos", data);
    },

    ActionSetPuertos({ commit }, data) {
      commit("setPuertos", data);
    },

    ActionSetPayers({ commit }, data) {
      commit("setPayers", data);
    },


    // Lineas-Bookings

    ActionSetClientes({ commit }, data) {
      commit("setClientes", data);
    },
    ActionSetServicioIntegral({ commit }, data) {
      commit("setServicioIntegral", data);
    },

    ActionSetNavieras({ commit }, data) {
      commit("setNavieras", data);
    },
    ActionSetNaves({ commit }, data) {
      commit("setNaves", data);
    },

    ActionSetTipoContratos({ commit }, data) {
      commit("setTipoContratos", data);
    },

    ActionSetCommodity({ commit }, data) {
      commit("setCommodity", data);
    },

    ActionSetAtmosferas({ commit }, data) {
      commit("setAtmosferas", data);
    },

    ActionSetContenedores({ commit }, data) {
      commit("setContenedores", data);
    },
    ActionSetEstadoAcuerdoLinea({ commit }, data) {
      commit("setEstadoAcuerdoLinea", data);
    },
    ActionSetEstadoContact({ commit }, data) {
      commit("setEstadoContact", data);
    },


    ActionSetPod({ commit }, data) {
      commit("setPod", data);
    },
    ActionSetPol({ commit }, data) {
      commit("setPol", data);
    },

    ActionSetComerciales({ commit }, data) {
      commit("setComerciales", data);
    },

    ActionSetProductos({ commit }, data) {
      commit("setProductos", data);
    },

    ActionSetTipoServicioIntegral({ commit }, data) {
      commit("setTipoServicioIntegral", data);
    },

    ActionSetMotivo({ commit }, data) {
      commit("setMotivo", data);
    },

    // End Lineas-Bookings
    ActionSetCargarTabla({ commit }, data) {
      commit("setCargarTabla", data);
    },

    ActionSetRefrescarTable({ commit }, data) {
      commit("setRefrescarTable", data);
    },

    ActionSetLoading({ commit }, data) {
      commit("setLoading", data);
    },
    ActionSetTipoTier({ commit }, data) {
      commit("setTipoTier", data);
    },

    ActionSetLoadingTable({ commit }, data) {
      commit("setLoadingTable", data);
    },

    ActionSetLoadingTableModal({ commit }, data) {
      commit("setLoadingTableModal", data);
    },

    ActionSetConfirmacionBtnEliminar({ commit }, data) {
      commit("setConfirmacionBtnEliminar", data);
    },

    ActionSetVisibleModalEditar({ commit }, data) {
      commit("setVisibleModalEditar", data);
    },
    // Admin
    ActionSetVisibleModalEditarBookingConfirmado({ commit }, data) {
      commit("setVisibleModalEditarBookingConfirmado", data);
    },
    ActionSetVisibleModalEditarBookingEmbarcado({ commit }, data) {
      commit("setVisibleModalEditarBookingEmbarcado", data);
    },
    ActionSetVisibleModalEditarSolicitudModificacion({ commit }, data) {
      commit("setVisibleModalEditarSolicitudModificacion", data);
    },
    ActionSetContratos({ commit }, data) {
      commit("setContratos", data);
    },
    // Fin Admin
    // Cliente
    ActionSetVisibleModalEditarBookingPorAceptar({ commit }, data) {
      commit("setVisibleModalEditarBookingPorAceptar", data);
    },
    // Fin Cliente
    ActionSetVisibleModalTracking({ commit }, data) {
      commit("setVisibleModalTracking", data);
    },

    ActionSetVisibleModalVerTracking({ commit }, data) {
      commit("setVisibleModalVerTracking", data);
    },

    ActionSetVisibleModalBL({ commit }, data) {
      commit("setVisibleModalBL", data);
    },

    ActionSetVisibleModalDetalleBL({ commit }, data) {
      commit("setVisibleModalDetalleBL", data);
    },

    ActionSetVisibleModalHistorial({ commit }, data) {
      commit("setVisibleModalHistorial", data);
    },

    //estado tipo proveedor
    ActionSetEstadoTipoProveedor({ commit }, data) {
      commit("setEstadoTipoProveedor", data);
    },

    ActionSetvisibleModalInformacionGeneral({ commit }, data) {
      commit("setVisibleModalInformacionGeneral", data);
    },

    // Modals editar campos proveedores

    ActionSetVisibleModalEditarProveedoresCoordinadores({ commit }, data) {
      commit("setVisibleModalEditarProveedoresCoordinadores", data);
    },

    ActionSetVisibleModalEditarProveedoresConductores({ commit }, data) {
      commit("setVisibleModalEditarProveedoresConductores", data);
    },

    ActionSetVisibleModalEditarProveedoresCamiones({ commit }, data) {
      commit("setVisibleModalEditarProveedoresCamiones", data);
    },

    ActionSetVisibleModalEditarProveedoresDatosBancarios({ commit }, data) {
      commit("setVisibleModalEditarProveedoresDatosBancarios", data);
    },

    // Modals editar campos embarcadores

    ActionSetVisibleModalEditarEmbarcadoresDirecciones({ commit }, data) {
      commit("setVisibleModalEditarEmbarcadoresDirecciones", data);
    },

    ActionSetVisibleModalEditarEmbarcadoresContactos({ commit }, data) {
      commit("setVisibleModalEditarEmbarcadoresContactos", data);
    },

    // Loading state aux
    ActionSetUploadFileLoading({ commit }, data) {
      commit("setUploadFileLoading", data);
    },

    ActionSetUploadFileLoadingError({ commit }, data) {
      commit("setUploadFileLoadingError", data);
    },

    ActionSetUploadFileId({ commit }, data) {
      commit("setUploadFileId", data);
    },

    ActionSetAnios({ commit }, data) {
      commit("setAnios", data);
    },

    ActionSetListaPallets({ commit }, data) {
      commit("setListaPallets", data);
    },

    ActionSetListaClientesUsuarioActual({ commit }, data) {
      commit("setListaClientesUsuarioActual", data);
    },

    ActionSetLoadingServiciosBooking({ commit }, data) {
      commit("setLoadingServiciosBooking", data);
    },

    // Diego
    ActionSetLoadingServiciosPuertos({ commit }, data) {
      commit("setLoadingServiciosPuertos", data);
    },
    ActionSetLoadingServiciosTransbordos({ commit }, data) {
      commit("setLoadingServiciosTransbordos", data);
    },
    ActionsetLoadingDestinoFinalItinerarios({ commit }, data) {
      commit("setLoadingDestinoFinalItinerarios", data);
    },
    // Daniel
    ActionSetLoadingItinerariosTransbordos({ commit }, data) {
      commit("setLoadingItinerariosTransbordos", data);
    },

    ActionSetZindexModal({ commit }, data) {
      commit("setZindexModal", data);
    },
    ActionSetZindexTablaModal({ commit }, data) {
      commit("setZindexTablaModal", data);
    },


    ActionSetShowAcuerdoLineas({ commit }, data) {
      commit("setShowAcuerdoLineas", data);
    },
    ActionSetShowAcuerdoLineasClienteBase({ commit }, data) {
      commit("setShowAcuerdoLineasClienteBase", data);
    },
    ActionSetShowAcuerdoClientes({ commit }, data) {
      commit("setShowAcuerdoClientes", data);
    },
    ActionsSetShowModalAcuerdoLineasClienteBase({ commit }, data) {
      commit("setShowModalAcuerdoLineasClienteBase", data);
    },
    ActionSetShowDescuentosClientes({ commit }, data) {
      commit("setShowDescuentosClientes", data);
    },
    // Shipping Instructions
    ActionSetShowShippingPorEnviar({ commit }, data) {
      commit("setShowShippingPorEnviar", data);
    },
    ActionSetShowShippingPorAprobar({ commit }, data) {
      commit("setShowShippingPorAprobar", data);
    },
    ActionSetShowShippingEnviadas({ commit }, data) {
      commit("setShowShippingEnviadas", data);
    },
    ActionSetShowShippingConfirmadas({ commit }, data) {
      commit("setShowShippingConfirmadas", data);
    },
    ActionSetShowShippingRechazadas({ commit }, data) {
      commit("setShowShippingRechazadas", data);
    },
    ActionSetShowShippingTemplates({ commit }, data) {
      commit("setShowShippingTemplates", data);
    },

    ActionSetShowModalBooking({ commit }, data) {
      commit("setShowModalBooking", data);
    },

    ActionSetAvatarMiniatura({ commit }, data) {
      commit("setAvatarMiniatura", data);
    },
    ActionSetCurrencies({ commit }, data) {
      commit("setCurrencies", data);
    },
    ActionSetExtraCost({ commit }, data) {
      commit("setExtraCost", data);
    },


  },

  modules: {
    modulosLogin,
    administracion,
    lineas,
    charter,
    liquidations,
    shippinginstructions,
    superadministrador,
    seccionesAdministrador,
    seccionesLineas,
    seccionesShippingInstructions,
    seccionesSuperAdministrador,
    subseccionesLineas,
    subseccionesAdministrador,
    serviciosLogisticos
  },
});
